"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");
/**
 *
 * @param isStopScroll boolean to turn off body scroll
 * also tacks the current style of body and reverts it
 * to previous default style it had before the change
 
 */


var useBodyScrollDisable = function useBodyScrollDisable(isStopScroll) {
  var _ref = (0, react_1.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      hasMounted = _ref2[0],
      setHasMounted = _ref2[1];

  var scrollOff = "overflow: hidden;",
      scrollOn = "overflow: unset;";

  var getBody = function getBody() {
    return (document === null || document === void 0 ? void 0 : document.querySelector("body")) || null;
  };

  (0, react_1.useEffect)(function () {
    var _a, _b;

    if (hasMounted && isStopScroll) {
      (_a = getBody()) === null || _a === void 0 ? void 0 : _a.setAttribute("style", scrollOff);
    } else if (hasMounted && !isStopScroll) {
      (_b = getBody()) === null || _b === void 0 ? void 0 : _b.setAttribute("style", scrollOn);
    }
  }, [isStopScroll]);
  (0, react_1.useEffect)(function () {
    setHasMounted(true);
    return function () {
      var body = getBody();
      body && body.setAttribute("style", scrollOff);
    };
  }, []);
};

exports.default = useBodyScrollDisable;